import {
  defineBKTConfigForReact,
  defineBKTUser,
  initializeBKTClient,
  getBKTClient,
  destroyBKTClient,
} from '@bucketeer/react-client-sdk';

// Feature flag IDs used for A/B testing (create these in Bucketeer with the same tag as featureTag)
export const BUCKETEER_FEATURE_IDS = {
  /** String flag: 'onboarding' | 'demo-account'. Tag: onboarding. When 'demo-account', /create-account auto-logs in with the shared demo user. */
  ONBOARDING_DEMO_ACCOUNT: 'onboarding-demo-account',
  /** String flag: 'onboarding-v1' | 'onboarding-v2'. Tag with featureTag so it is evaluated. */
  ONBOARDING_VERSION: 'onboarding-version',
  /** String flag: 'a' | 'b'. Controls which frontend build the user sees. Tag with featureTag. */
  FRONTEND_AB_VERSION: 'frontend-ab-version',
  /** Boolean flag: true | false. Controls whether new users see the guided joyride onboarding tour. */
  JOYRIDE_ONBOARDING: 'joyride-onboarding',
};

/** Wraps fetch to log Bucketeer API responses for debugging. */
const fetchWithLogging = async (url, options) => {
  const res = await fetch(url, options);
  const cloned = res.clone();
  try {
    const data = await cloned.json();
    console.log('[Bucketeer] API response', { url, status: res.status, data });
  } catch {
    // non-JSON or empty body
  }
  return res;
};

let _bucketeerConfig = null;
try {
  if (import.meta.env.VITE_APP_BUCKETEER_API_KEY) {
    _bucketeerConfig = defineBKTConfigForReact({
      apiKey: import.meta.env.VITE_APP_BUCKETEER_API_KEY,
      apiEndpoint: import.meta.env.VITE_APP_BUCKETEER_API_ENDPOINT,
      appVersion: '1.0.0',
      featureTag: 'onboarding',
      fetch: fetchWithLogging,
    });
  }
} catch (e) {
  console.warn('Bucketeer config failed:', e.message);
}
export const bucketeerConfig = _bucketeerConfig;
export const BUCKETEER_ANONYMOUS_ID_KEY = 'bucketeer_anonymous_id';

export const getBucketeerAnonymousId = () => {
  try {
    let id = localStorage.getItem(BUCKETEER_ANONYMOUS_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(BUCKETEER_ANONYMOUS_ID_KEY, id);
    }
    return id;
  } catch (error) {
    // localStorage may be unavailable (privacy mode); fallback to ephemeral id.
    return crypto.randomUUID();
  }
};

export const createBucketeerUser = (userId, attributes = {}) =>
  defineBKTUser({
    id: userId,
    customAttributes: attributes,
  });

export { initializeBKTClient, getBKTClient, destroyBKTClient };
